import React, { Component } from "react"
import { Button, FormControl, Modal } from "react-bootstrap";
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder";
import "./DocDownloader.css"

interface Props {
    file: any
    extension: string
    fileName: string | null
    toggleDownload: Function
    displayName: string
}

interface State {
    confirmDownload: boolean
    input: string
}

class DocDownloader extends Component<Props, State> {

    state = {
        confirmDownload: false,
        input: ""
    }

    componentDidMount() {
        //@ts-ignore
        this.manageState([{ key: "input", value: this.props.displayName.replace(/\.[^/.]+$/, "") }])
    }

    handleChange = (event: { target: { value: string } }) => {
        this.setState({ input: event.target.value })
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }

    download = () => {
        const link = document.createElement("a")
        link.href = this.props.file
        link.download = `${this.state.input}.${this.props.extension}`
        document.body.appendChild(link)
        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        )
        document.body.removeChild(link)
        this.manageState([{ key: "confirmDownload" }])
    }


    render() {

        const state = this.state
        // //console.log("state:", state)
        // //console.log("props:", props)

        return (

            <div className="DocDownloader">
                {!this.state.confirmDownload && <span className="material-icons" onClick={() => this.manageState([{ key: "confirmDownload" }])}>download</span>}
                {state.confirmDownload && <Modal id="doc-downloader-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="DocDownloaderModalHeader">
                            <IconBuilder
                                extension={this.props.extension}
                                size={32}
                            />
                            <p>{this.props.extension}</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="DocDownloaderModalBody">
                            <FormControl
                                //@ts-ignore
                                placeholder={"Save as..."}
                                onChange={this.handleChange}
                                value={this.state.input}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="DocDownloaderModalFooter">
                            {state.input.length > 0 && <span id="doc-downloader-modal-footer-can-download" className="material-icons" onClick={() => this.download()}>download</span>}
                            {state.input.length === 0 && <span id="doc-downloader-modal-footer-cant-download" className="material-icons" onClick={() => this.download()}>download</span>}
                            <Button variant="primary" onClick={() => this.manageState([{ key: "confirmDownload" }])}>Back</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
            </div>
        )
    }
}

export default DocDownloader